var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.875a.376.376 0 0 1-.375-.375v-9c0-.206.169-.375.375-.375h3.75V4c0 .415.335.75.75.75h1.875v6.75a.376.376 0 0 1-.375.375zM4 1c-.827 0-1.5.673-1.5 1.5v9c0 .828.673 1.5 1.5 1.5h6c.827 0 1.5-.672 1.5-1.5V4.622a1.5 1.5 0 0 0-.438-1.062L8.938 1.439A1.5 1.5 0 0 0 7.878 1zm1.313 6a.56.56 0 0 0-.563.563c0 .312.25.562.563.562h3.375a.561.561 0 1 0 0-1.125zm0 2.25a.56.56 0 0 0-.563.563c0 .312.25.562.563.562h3.375a.561.561 0 1 0 0-1.125z"
  })));
};
export default SvgDocument;